import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/system',
  component: Layout,
  name: 'systemManagement',
  meta: {
    title: '系统管理',
    icon: 'i-ep:setting',
    menu: false,
  },
  children: [
    {
      path: 'role',
      name: 'systemRole',
      component: () => import('@/views/system/role/index.vue'),
      meta: {
        title: '角色管理',
        icon: 'i-ep:user-filled',
      },
    },
    {
      path: 'menu',
      name: 'systemMenu',
      component: () => import('@/views/system/menu/index.vue'),
      meta: {
        title: '菜单管理',
        icon: 'i-ep:menu',
      },
    },
    {
      path: 'permission',
      name: 'systemPermission',
      component: () => import('@/views/system/permission/index.vue'),
      meta: {
        title: '权限分配',
        icon: 'i-ep:key',
      },
    },
    {
      path: 'module',
      name: 'systemModule',
      component: () => import('@/views/system/module/index.vue'),
      meta: {
        title: '系统模块管理',
        icon: 'i-ep:grid',
      },
    },
    {
      path: 'module/route-config',
      name: 'systemModuleRouteConfig',
      component: () => import('@/views/system/module/route-config.vue'),
      meta: {
        title: '路由配置管理',
        icon: 'i-ep:menu',
        menu: false, // 不在菜单中显示，只能通过跳转访问
      },
    },
    {
      path: 'admin',
      name: 'systemAdmin',
      component: () => import('@/views/system/admin/index.vue'),
      meta: {
        title: '管理员管理',
        icon: 'i-ep:user-filled',
      },
    },
    {
      path: 'admin/add',
      name: 'systemAdminAdd',
      component: () => import('@/views/system/admin/add.vue'),
      meta: {
        title: '添加管理员',
        icon: 'i-ep:plus',
        menu: false, // 不在菜单中显示，只能通过跳转访问
      },
    },
    {
      path: 'workflow',
      name: 'systemWorkflow',
      component: () => import('@/views/workflow/index.vue'),
      meta: {
        title: '审批流管理',
        icon: 'i-ep:connection',
      },
    },
    {
      path: 'workflow/designer/:id?',
      name: 'systemWorkflowDesigner',
      component: () => import('@/views/workflow/designer.vue'),
      meta: {
        title: '流程设计器',
        icon: 'i-ep:edit',
        menu: false, // 不在菜单中显示，只能通过跳转访问
      },
    },
    {
      path: 'admin/edit/:id',
      name: 'systemAdminEdit',
      component: () => import('@/views/system/admin/edit.vue'),
      meta: {
        title: '编辑管理员',
        icon: 'i-ep:edit',
        menu: false, // 不在菜单中显示，只能通过跳转访问
      },
    },
    {
      path: 'settings/site-info',
      name: 'systemSiteInfo',
      component: () => import('@/views/system/settings/site-info.vue'),
      meta: {
        title: '站点设置',
        icon: 'i-ep:info-filled',
      },
    },
    {
      path: 'settings/system-config',
      name: 'systemConfig',
      component: () => import('@/views/system/settings/system-config.vue'),
      meta: {
        title: '系统配置',
        icon: 'i-ep:setting',
      },
    },
    {
      path: 'settings/dictionary',
      name: 'systemDictionary',
      component: () => import('@/views/system/settings/dictionary.vue'),
      meta: {
        title: '系统字典',
        icon: 'i-ep:collection',
      },
    },
    {
      path: 'settings/config-field/add',
      name: 'systemConfigFieldAdd',
      component: () => import('@/views/system/settings/config-field-form.vue'),
      meta: {
        title: '添加配置字段',
        icon: 'i-ep:plus',
        menu: false, // 不在菜单中显示
      },
    },
    {
      path: 'settings/config-field/edit/:id',
      name: 'systemConfigFieldEdit',
      component: () => import('@/views/system/settings/config-field-form.vue'),
      meta: {
        title: '编辑配置字段',
        icon: 'i-ep:edit',
        menu: false, // 不在菜单中显示
      },
    },

  ],
}

export default routes
